import { render, staticRenderFns } from "./caishenwins.vue?vue&type=template&id=73100ea2&scoped=true"
import script from "./caishenwins.vue?vue&type=script&lang=js"
export * from "./caishenwins.vue?vue&type=script&lang=js"
import style0 from "./caishenwins.vue?vue&type=style&index=0&id=73100ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73100ea2",
  null
  
)

export default component.exports